define('models/accounts/accountsummary',[
    'backbone',
    'models/accounts/accountsummary_collection'
], function(Backbone, AccountSummaryList){
    var AccountSummary = Backbone.Model.extend({
        url: function(pn){
            var url = pf.consumerURL + "/Accounts";

            if(pn != null){
                url += "/" + pn;
            } else {
                url += "/" + 1;
            }

            return url;
        },
        initialize: function(options){
            options = options || {};
            this.AccountGUID = options.AGID;
            this.AccountName = options.AN;
            this.Balance = options.B;
            this.TargetAmount = options.TA;
            this.Reference = options.CN;
            this.AccountNumber = options.ACN;
            this.ImageName = buildImageURL(pf.enums.entityTypeCodeEnum.Account, options.AGID, pf.enums.imageTypeGUIDEnum.Actual, options.IMN);
            this.Allocators = options.AC;
            this.Participants = options.PC;
            this.PurseCount = options.PLC;
            this.PurseAccounts = options.PA;
            //this.PurseAccounts = new AccountSummaryList(options.PA, { parse: true });
            this.AccountTypeID = options.ATID;
            this.CertificationTypeID = options.CTID;
            this.ProxyPurseNumber = options.PPN;
            this.PendingTransactionBalance = options.PTB;
            this.BankAccountStatus = options.BAS;
            this.BankNickName = options.BNN;
            this.CardStatusID = options.CSID;
            this.CardStatus = options.CS;
            this.LastFourCardNumber = options.CN;
            this.CardTypeID = options.CATID;
        },
        parse: function(data){
            var response = {};
            response.AccountGUID = data.AGID;
            response.AccountName = data.AN;
            response.Balance = data.B;
            response.TargetAmount = data.TA;
            response.Reference = data.CN;
            response.AccountNumber = data.ACN;
            response.ImageName = buildImageURL(pf.enums.entityTypeCodeEnum.Account, data.AGID, pf.enums.imageTypeGUIDEnum.Actual, data.IMN);
            response.Allocators = data.AC;
            response.Participants = data.PC;
            response.PurseCount = data.PLC;
            response.PurseAccounts = data.PA;
            //response.PurseAccounts = new AccountSummaryList(data.PA, { parse: true });
            response.AccountTypeID = data.ATID;
            response.CertificationTypeID = data.CTID;
            response.ProxyPurseNumber = data.PPN;
            response.PendingTransactionBalance = data.PTB;
            response.BankAccountStatus = data.BAS;
            response.BankNickName = data.BNN;
            response.CardStatusID = data.CSID;
            response.CardStatus = data.CS;
            response.LastFourCardNumber = data.CN;
            response.CardTypeID = data.CATID;
            return response;
        },
        save: function(attributes, options){
            options = options || {};
            attributes = attributes || {};;

            var data = {};
            //data.ID = this.attributes.AccountDetailID;
            //data.AID = this.attributes.AccountID;
            //data.LFCN = this.attributes.LastFourCardNumber;
            //data.ABAL = this.attributes.AvailableBalance;
            //data.SUS = this.attributes.Suspended;
            //data.PR = this.attributes.PendingRebates;
            //data.AP = this.attributes.AllocationPercent;
            //data.RFP = this.attributes.YTDRebatesFromPurchases;
            //data.RFM = this.attributes.YTDRebatesFromMembers;
            //data.DFA = this.attributes.YTDDonationsFromAccount;
            //data.DFO = this.attributes.YTDDonationsFromOthers;

            this.attributes = data;

            return Backbone.Model.prototype.save.call(this, attributes, options);
        }
    });
    return AccountSummary;
});
